var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconLogin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_Login",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schnittmenge_1",
    "data-name": "Schnittmenge 1",
    transform: "translate(5 17)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.25V7A7,7,0,0,1,7,0h6a7,7,0,0,1,7,7V9.25A15.2,15.2,0,0,1,10,13,15.2,15.2,0,0,1,0,9.25Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.999899864196777 10.99960041046143 C 12.88585662841797 10.99960041046143 15.69397640228271 10.04634952545166 17.99979972839355 8.298955917358398 L 17.99979972839355 7.000200271606445 C 17.99979972839355 4.243080139160156 15.75712013244629 2.000000238418579 13.0004997253418 2.000000238418579 L 6.999300003051758 2.000000238418579 C 4.242680072784424 2.000000238418579 1.99999988079071 4.243080139160156 1.99999988079071 7.000200271606445 L 1.99999988079071 8.298965454101562 C 4.30582332611084 10.04635810852051 7.113943576812744 10.99960041046143 9.999899864196777 10.99960041046143 M 9.999899864196777 12.99960041046143 C 6.186389923095703 12.99960041046143 2.695299863815308 11.58870983123779 -1.358032193365943e-07 9.250450134277344 L -1.358032193365943e-07 7.000200271606445 C -1.358032193365943e-07 3.133800268173218 3.13379979133606 2.052307195299363e-07 6.999300003051758 2.052307195299363e-07 L 13.0004997253418 2.052307195299363e-07 C 16.86599922180176 2.052307195299363e-07 19.99979972839355 3.133800268173218 19.99979972839355 7.000200271606445 L 19.99979972839355 9.25044059753418 C 17.30450057983398 11.58870983123779 13.81340980529785 12.99960041046143 9.999899864196777 12.99960041046143 Z",
    stroke: "none",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(9 4)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLogin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-login.6466d1b7.svg";
export { ForwardRef as ReactComponent };